(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 30677:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(28143);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Cookies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50921);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);




function Cookies(props) {
    if (props.showPolicy) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            id: "cookies",
            className: "fixed w-full bottom-0 z-50 p-3 mb-0 bg-slate-400 flex justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    onClick: function() {
                        return props.setShowPolicy(false);
                    },
                    className: "mx-3 text-white hover:text-slate-300",
                    style: {
                        fontSize: 25
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-white text-center mb-0",
                    children: [
                        "By using this site, you agree to our",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: "/cookie-policy",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-white",
                                    children: " Cookie Policy "
                                })
                            })
                        }),
                        "and",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: "/privacy-policy",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-white",
                                    children: " Privacy Policy"
                                })
                            })
                        })
                    ]
                })
            ]
        }));
    }
    return null;
};


/***/ }),

/***/ 93674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(33587);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MenuIcon.js
var MenuIcon = __webpack_require__(69065);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
// EXTERNAL MODULE: ./contexts/Auth.js
var Auth = __webpack_require__(92842);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next-intercom/dist/index.js
var dist = __webpack_require__(33854);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(52500);
// EXTERNAL MODULE: ./components/Cookies.js
var Cookies = __webpack_require__(36076);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
;// CONCATENATED MODULE: ./components/Layouts/Navbars/HomeNav.js













var navigation = [
    // { name: 'Product', href: '#' },
    {
        name: 'AI Generator',
        href: '/ai-tools'
    },
    {
        name: 'Directory',
        href: '/directory'
    },
    {
        name: 'Guides',
        href: '/guides'
    },
    {
        name: 'Blog',
        href: '/blog'
    }, 
];
function HomeNav() {
    var ref = (0,Auth/* useAuth */.a)(), user = ref.user, signOut = ref.signOut;
    var ref1 = (0,react.useState)(false), showPolicy = ref1[0], setShowPolicy = ref1[1];
    (0,react.useEffect)(function() {
        if (!config/* dev */.WI && user) {
            (0,dist.loadIntercom)({
                appId: 'zpntjk45',
                name: "",
                email: user ? user.email : "",
                ssr: false,
                initWindow: true,
                delay: 2000
            });
        } else if (!config/* dev */.WI) {
            (0,dist.loadIntercom)({
                appId: 'zpntjk45',
                ssr: false,
                initWindow: true,
                delay: 2000
            });
        }
        var cook = (0,lib.getCookie)("policy");
        if (!cook) {
            setShowPolicy(true);
            (0,lib.setCookie)("policy", "true");
        }
    }, [
        user
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
        as: "header",
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cookies/* default */.Z, {
                showPolicy: showPolicy,
                setShowPolicy: setShowPolicy
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-slate-200/50 pt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: "relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6",
                    "aria-label": "Global",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center flex-1 justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between w-full md:w-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Plaza"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                        alt: "Plaza Logo",
                                                        src: "https://d28zq0um2frnpx.cloudfront.net/static/plaza-logto-tail.png",
                                                        width: 128,
                                                        height: 64,
                                                        objectFit: "contain"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "-mr-2 flex items-center md:hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                className: "bg-gray-900 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-800 focus:outline-none focus:ring-2 focus-ring-inset focus:ring-white",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open main menu"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon/* default */.Z, {
                                                        className: "h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden space-x-8 md:!flex md:ml-10 md:mr-10",
                                    children: navigation.map(function(item) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: item.href,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-base font-medium text-slate-500 hover:text-gray-800",
                                                children: item.name
                                            })
                                        }, item.name);
                                    })
                                })
                            ]
                        }),
                        user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:!flex md:items-center md:space-x-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center text-base font-medium text-gray-600",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return signOut();
                                        },
                                        className: "text-gray-900 hover:underline",
                                        children: "Logout"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/dashboard",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700",
                                        children: "Dashboard"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:!flex md:items-center md:space-x-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-base font-medium text-slate-900 hover:text-gray-600",
                                        children: "Log in"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/#bookDemo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700",
                                        children: "Book a Demo"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                as: react.Fragment,
                enter: "duration-150 ease-out",
                enterFrom: "opacity-0 scale-95",
                enterTo: "opacity-100 scale-100",
                leave: "duration-100 ease-in",
                leaveFrom: "opacity-100 scale-100",
                leaveTo: "opacity-0 scale-95",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                    focus: true,
                    className: "absolute z-10 top-0 inset-x-0 p-2 transition transform origin-top md:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-5 pt-4 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            alt: "Plaza",
                                            src: "https://d28zq0um2frnpx.cloudfront.net/static/plaza-logto-tail.png",
                                            width: 128,
                                            height: 64,
                                            objectFit: "contain"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "-mr-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                            className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-fuchsia-600",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close menu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                                    className: "h-6 w-6",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-5 pb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-2 space-y-1",
                                        children: navigation.map(function(item) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: item.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50",
                                                    children: item.name
                                                })
                                            }, item.name);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6 px-5",
                                        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: "/dashboard",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "block text-center w-full py-3 px-4 rounded-md shadow shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-900",
                                                        children: "Dashboard"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-center mt-4 text-base font-medium text-gray-600",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: function() {
                                                            return signOut();
                                                        },
                                                        className: "text-gray-900 hover:underline",
                                                        children: "Logout"
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-6 px-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: "/#bookDemo",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "block text-center w-full py-3 px-4 rounded-md shadow shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-900",
                                                            children: "Book a Demo"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-center text-base font-medium text-gray-600",
                                                    children: [
                                                        "Existing customer?",
                                                        ' ',
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                            href: "/login",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "text-gray-900 hover:underline",
                                                                children: "Login"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
;// CONCATENATED MODULE: ./components/Layouts/homeLayout.js



var Footer = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 3474).then(__webpack_require__.bind(__webpack_require__, 73193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73193)
            ];
        }
    }
});
function Layout(param) {
    var children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNav, {}),
            children
        ]
    }));
};


/***/ }),

/***/ 18549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);


//Could use a package called next-seo
function Meta(param) {
    var title = param.title, description = param.description, image = param.image, url = param.url;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "viewport",
                    content: "width=device-width, initial-scale=1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    charSet: "utf-8"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "icon",
                    href: "/favicon.ico"
                }),
                url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "canonical",
                            href: url
                        }, "canonical"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:url",
                            content: url
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "website"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: "https://plaza.so/"
                }),
                image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: image
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: title
                })
            ]
        })
    }));
};


/***/ }),

/***/ 28143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Blog; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52500);
/* harmony import */ var _components_Layouts_homeLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93674);
/* harmony import */ var _contexts_Auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92842);
/* harmony import */ var _components_Notification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96691);
/* harmony import */ var react_alert__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19412);
/* harmony import */ var _components_Meta__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18549);










function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var DateTime = (__webpack_require__(68565)/* .DateTime */ .ou);
var features = (/* unused pure expression or super */ null && ([
    "Scheduling pages to collect bookings",
    "Customizable video chat",
    "Automatic email reminders",
    "Upload logo once to brand all assets (scheduling, video chat, email reminders)",
    "Automatic cancellation and rescheduling",
    "Goal tracking",
    "Client Portal"
]));
var __N_SSG = true;
function Blog(param) {
    var articles = param.articles;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-slate-200/50 pb-36 h-full pt-5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Meta__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                title: "Plaza Blog Articles",
                description: "Find helpful information on how to recover from burnout or grow as an online coach"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " text-left overflow-hidden py-20 flex flex-col items-baseline bg-slate-200/80 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-4 w-3/4 mx-auto z-20 ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "font-extrabold text-4xl text-slate-800 ",
                            children: "Blog Articles"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "font-extrabold text-xl text-slate-500 ",
                            children: "Burnout recovery and coaching resources"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute top-0 mt-36 h-full w-full overflow-hidden z-10",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative h-full overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                            className: "absolute right-full transform translate-y-1/3 translate-x-1/4 md:translate-y-1/2 sm:translate-x-1/2 lg:translate-x-full",
                            width: 404,
                            height: 784,
                            fill: "none",
                            viewBox: "0 0 404 784",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pattern", {
                                        id: "e229dbec-10e9-49ee-8ec3-0286ca089edf",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                    width: 404,
                                    height: 784,
                                    fill: "url(#e229dbec-10e9-49ee-8ec3-0286ca089edf)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                            className: "absolute overflow-hidden left-full transform -translate-y-3/4 -translate-x-1/4 sm:-translate-x-1/2 md:-translate-y-1/2 lg:-translate-x-3/4",
                            width: 404,
                            height: 784,
                            fill: "none",
                            viewBox: "0 0 404 784",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pattern", {
                                        id: "d2a68204-c383-44b1-b99f-42ccff4e5365",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                    width: 404,
                                    height: 784,
                                    fill: "url(#d2a68204-c383-44b1-b99f-42ccff4e5365)"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " pt-5 text-left pb-48 z-20 relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-wrap w-3/4 mx-auto justify-evenly",
                    children: articles.map(function(article) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "md:w-[30%] sm:w-[45%] p-5 m-2 rounded-lg shadow border bg-white",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: "/blog/".concat(article.slug),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "italic text-slate-500 text-sm",
                                            children: DateTime.fromISO(article.date_published).toFormat("DDD")
                                        }),
                                        article.cover_image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                src: "https://d28zq0um2frnpx.cloudfront.net/media/article_images/" + article.cover_image,
                                                height: 300,
                                                width: 900,
                                                alt: article.cover_image_alt,
                                                className: "rounded-lg",
                                                objectFit: "cover"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-slate-800 text-xl font-bold mb-2",
                                            children: article.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-slate-600 text-md",
                                            children: article.content.substring(0, 130).replace(/<[^>]*>?/gm, '')
                                        })
                                    ]
                                })
                            })
                        }, article.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full flex justify-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-slate-500",
                    children: "\xa9 2023 Ordinary Media, LLC. All Rights Reserved."
                })
            })
        ]
    }));
};
var alertOptions = {
    // you can also just use 'bottom right'
    position: react_alert__WEBPACK_IMPORTED_MODULE_7__/* .positions.BOTTOM_RIGHT */ .m7.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: {
        'zIndex': '9999'
    },
    // you can also just use 'fade'
    transition: react_alert__WEBPACK_IMPORTED_MODULE_7__/* .transitions.FADE */ .pB.FADE
};
Blog.getLayout = function getLayout(page) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_alert__WEBPACK_IMPORTED_MODULE_7__/* .Provider */ .zt, _objectSpread({
        template: _components_Notification__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
    }, alertOptions, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_Auth__WEBPACK_IMPORTED_MODULE_5__/* .AuthProvider */ .H, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layouts_homeLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: page
            })
        })
    })));
};


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9225,5675,3640,3616,7612,9774,2888,179], function() { return __webpack_exec__(30677); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);